export default __webpack_public_path__ + "static/media/cauliflowerbites-wide@3x.cab974a0.jpg";